"use client";

import React, { useEffect } from "react";
import { styled } from "styled-components";

import { useNavigate } from "react-router-dom";
import { TICKET_TYPE } from "@src/components/deungi/common/enum";
import { Common } from "@src/styles/Common";
import { useFindOneUserSubsInfo } from "@src/hooks/user/userApi";
import { useLandRegisterIssueCount } from "@src/hooks/landRegister/useLandRegister";
import { useFindOneTicketCount } from "@src/hooks/deungi/useTicketCount";
export const MAX_REGISTER_TICKET = 20;

const LandRegisterTicketBoard = () => {
    const navigate = useNavigate();

    const { data: userSubsProductInfo, refetch: refetchUserSubsProductInfo } = useFindOneUserSubsInfo();
    const { data: ticketCount, refetch: refetchTicketCount } = useFindOneTicketCount(TICKET_TYPE.LAND_REGISTER_TICKET);
    const { data: landRegisterIssueCount, refetch: refetchCount } = useLandRegisterIssueCount();

    const onClickHandler = () => {
        navigate("/landRegister/payment");
    };

    // vip 유저가 충전 불가능(무료 제공받은 20장 소진전까지)
    const isDisabledCharge = userSubsProductInfo?.subsName === "프리미엄" && landRegisterIssueCount < MAX_REGISTER_TICKET;

    useEffect(() => {
        refetchUserSubsProductInfo();
        refetchCount();
        refetchTicketCount();
    }, []);
    return (
        <Container>
            <TicketTitle>
                <p>
                    <span>Live</span>실시간 토지임야대장 열람권
                </p>
                <div>
                    {isDisabledCharge && (
                        <small className="premium">VIP 일일 {MAX_REGISTER_TICKET - landRegisterIssueCount || 0}/20장</small>
                    )}
                    {!isDisabledCharge && <small>{ticketCount?.curHaveCnt || 0}장</small>}
                    {!isDisabledCharge && (
                        <div className="chargeBtn" onClick={onClickHandler}>
                            <span>+</span>충전
                        </div>
                    )}
                </div>
            </TicketTitle>
        </Container>
    );
};

const Container = styled.div`
    padding: 0 14px;
    margin-bottom: 14px;
`;

const TicketTitle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 55px;
    background: #fdfafa;
    border-radius: 14px;
    padding: 0 8px;
    box-sizing: border-box;

    .premium {
        width: 100%;
        background: ${Common.colors.discoColor};
        color: #fff;
        padding: 2px 4px;
        border-radius: 100px;
        text-align: center;
        font-size: 12px;
    }
    p {
        font-size: 14px;
        font-weight: 700;
        line-height: 26px;
        color: #0c002c;
        & > span {
            border-radius: 100px;
            background-color: #f6494b;
            display: inline-block;
            padding: 4px;
            color: #ffffff;
            text-align: center;
            font-size: 14px;
            font-weight: 700;
            line-height: 14px;
            margin-right: 4px;
        }
    }
    & > div {
        display: flex;
        align-items: center;
        font-size: 14px;
        small {
            font-size: 14px;
            font-weight: 400;
        }
        .lottie {
            width: 40px;
        }
        .chargeBtn {
            display: flex;
            align-items: center;
            font-weight: 500;
            height: 28px;
            padding: 4px 14px;
            margin-left: 10px;
            background: #0047ff;
            border: none;
            border-radius: 24px;
            color: #fff;
            cursor: pointer;

            & > span {
                font-weight: 500;
                font-size: 15px;
                color: #fff;
                margin-right: 3px;
            }
        }
    }
`;

export default LandRegisterTicketBoard;
